import {env} from '../../../environment'

/**
 * Available Bodoscope tracking actions
 * @constant
 */
export const BODOSCOPE_ACTIONS = {
  wishList: 'wishlist',
  addToCart: 'cart',
  orderSuccess: 'checkout',
  pes: 'view'
} as const

/**
 * Valid action types for Bodoscope tracking events
 * @typedef {('wishlist' | 'cart' | 'checkout' | 'view')} BodoscopeAction
 */
type BodoscopeAction = typeof BODOSCOPE_ACTIONS[keyof typeof BODOSCOPE_ACTIONS];

/**
 * SKU identifier for Bodoscope events
 * @typedef {string} BodoscopeSku
 */
type BodoscopeSku = string;

/**
 * Sends a tracking event to the Bodoscope API
 *
 * @param {BodoscopeAction} action - The type of action being tracked (wishlist, cart, checkout, or view)
 * @param {BodoscopeSku} sku - The product SKU identifier (expected to be an array of SKU strings)
 * @returns {Promise<Response | void>} Promise that resolves with the fetch response or rejects on error
 *
 * @example
 * sendBodoscopeEvent('cart', ['SKU-12345', 'SKU-67890'])
 *   .then(() => console.log('Event tracked'))
 *   .catch(err => console.error('Tracking failed', err));
 */
export const sendBodoscopeEvent = (
  action: BodoscopeAction,
  sku: BodoscopeSku,
): Promise<Response | void> => {
  const endpoint = `${env.getServiceHost()}app/bodoscope`

  if (!action || !sku) {
    console.warn('Invalid action or sku')

    return Promise.reject('Invalid action or sku')
  }

  const url =
    endpoint +
    '?action=' +
    encodeURIComponent(action) +
    '&sku=' +
    encodeURIComponent(sku)

  return fetch(url).catch(err => {
    console.error('Bodoscope POST failed:', err)
  })
}